import { ActivityObserverProvider } from "@ch/components/ActivityObserverContextProvider";
import Header from "@ch/components/Header";
import LogoutConfirmModal from "@ch/components/Modals/LogoutConfirmModal";
import NotificationProvider from "@ch/components/NotificationProvider/NotificationProvider";
import Sidebar from "@ch/components/Sidebar";
import useGetUser from "@ch/helpers/hooks/useGetUser";
import { useNavigateLog } from "@ch/helpers/hooks/useNavigateLog";
import useUserDetails from "@ch/helpers/hooks/useUserDetails";
import BannerChatsDisabledWarning from "@ch/pages/RootPage/components/BannerChatsDisabledWarning.tsx";
import { type FC, useEffect } from "react";
import { Outlet } from "react-router-dom";

const RootPage: FC = () => {
  useNavigateLog();

  const { userId } = useUserDetails();

  const { initiateGetUser } = useGetUser();

  // Refresh the user data on page load
  useEffect(() => {
    if (!userId) {
      return;
    }

    void initiateGetUser({ userId });
  }, [initiateGetUser, userId]);

  return (
    <NotificationProvider>
      <ActivityObserverProvider>
        {({ throttledTriggerActivity }) => (
          <div
            className="flex h-[100dvh] flex-row overflow-hidden bg-white-400"
            onKeyDownCapture={() => {
              throttledTriggerActivity();
              return false;
            }}
            onPointerMoveCapture={() => {
              throttledTriggerActivity();
              return false;
            }}
          >
            <Sidebar />
            <section className="flex h-full min-w-[20rem] flex-1 flex-col items-stretch overflow-y-auto overscroll-contain sm:overflow-y-visible">
              <BannerChatsDisabledWarning />
              <Header />
              <main className="flex-1 overscroll-contain px-4 pb-12 pt-6 sm:overflow-y-auto sm:px-8">
                <Outlet />
              </main>
            </section>
            <LogoutConfirmModal />
          </div>
        )}
      </ActivityObserverProvider>
    </NotificationProvider>
  );
};

export default RootPage;
